module.exports = __webpack_public_path__ + "img/Ivanov-1-3000x2950-2.450399fd.jpg";